import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { buildMenuData } from '../data/utils/buildMenuData';
import { useFetch } from '../data/fetch/useFetch';
import { getConfiguration } from '../data/utils/configuration';
import Loader from '../common/Loader';
import { useSetSection } from '../common/SectionProvider';

export const PrematchDataContext = React.createContext(null);

export function usePrematchData() {
    return useContext(PrematchDataContext);
}

export default function PrematchDataProvider() {
    const conf = getConfiguration();
    useSetSection('prematch');

    const [isLoading, isError, data] = useFetch(conf.api.getMenuPrematch, null, (data) => {
        const parsedData = buildMenuData(data);
        if (parsedData) {
            parsedData.nel = data.nel;
            parsedData.nep = data.nep;
        }
        return parsedData;
    });

    if (isLoading || isError) {
        return (
            <Loader error={isError} />
        );
    }

    return (
        <PrematchDataContext.Provider value={data}>
            <Outlet />
        </PrematchDataContext.Provider>
    );
}
